import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (overrideClasses?: any) =>
  createStyles({
    skeleton: { minWidth: '11rem' },
    text: {
      fontWeight: 500,
      fontSize: 14,
    },
    textYellow: {
      color: palette.navCompanyContextActions,
    },
    textGreen: {
      color: palette.navAdminActions,
    },
    textBlue: {
      color: palette.navOperatorActions,
    },
    textGray: {
      color: palette.navSuperAdminActions,
    },
    filterButton: {
      padding: 0,
      marginLeft: 15,
      '& .MuiButton-endIcon': { marginLeft: 1 },
    },
    endIcon: { marginLeft: '0px !important' },
    endIconYellow: { color: palette.navCompanyContextActions },
    endIconBlue: { color: palette.navOperatorActions },
    endIconGreen: { color: palette.navAdminActions },
    endIconGray: { color: palette.navSuperAdminActions },

    button: {
      borderRadius: '0.5rem',
      border: `0.1rem solid ${palette.black}`,
    },
    styledMenu: {},
    listItem: { '& .MuiTypography-body1': { fontSize: 12 } },
    ...overrideClasses,
  });
